import { render, staticRenderFns } from "./EProposalIndex.vue?vue&type=template&id=5311c57c&"
import script from "./EProposalIndex.vue?vue&type=script&lang=js&"
export * from "./EProposalIndex.vue?vue&type=script&lang=js&"
import style0 from "./EProposalIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports